import { useMemo } from 'react';

import { HEADERS } from './constants';

import { processTableFilterOptions } from '../../utils/table-helpers';
import { useFlags } from 'launchdarkly-react-client-sdk';

const useBuildFilterOptions = ({ results }) => {
  return useMemo(() => {
    const options = {
      affordablePrograms: [],
      preferredUnitSize: [],
      incomeLevel: [],
      requestingAccommodation: [],
      status: [],
      householdStatus: [],
    };
    if (results) {
      results.forEach((result) => {
        if (result.affordablePrograms) {
          options.affordablePrograms.push(result.affordablePrograms);
        }
        if (result.preferredUnitSize) {
          options.preferredUnitSize.push(result.preferredUnitSize);
        }
        if (result.incomeLevel) {
          options.incomeLevel.push(result.incomeLevel);
        }
        if (result.applicationStatus?.name) {
          options.status.push(result.applicationStatus?.name);
        }
        options.requestingAccommodation.push(
          result.requestingAccommodation ? 'Yes' : 'No',
        );
        if (result?.householdStatus) {
          options.householdStatus.push(result?.householdStatus);
        }
      });
    }

    // Remove duplicates, sort, and map to label/value objects
    processTableFilterOptions(options);

    return options;
  }, [results]);
};

const useHeaders = ({ results }) => {
  // Add filters if needed later
  const filterOptions = useBuildFilterOptions({ results });
  const { affordableWaitlistV2 } = useFlags();

  return useMemo(() => {
    const headers = [];

    // Add headers
    HEADERS(affordableWaitlistV2).forEach((header) => {
      headers.push({
        ...header,
        filterOptions: header.filterOptions ?? filterOptions[header.id],
      });
    });

    return headers;
  }, [filterOptions]);
};

export default useHeaders;
